import { styled, Box, TextField, keyframes } from '@mui/material';
import { ReactComponent as SendIcon } from '../../../../assets/icons/SendIcon.svg';

export const AssistantBubble = styled(Box)(({ theme }) => ({
  borderRadius: 10,
  padding: '10px 15px',
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.common.white,
  maxWidth: '70%',
  wordWrap: 'break-word',
  marginBottom: 10,
}));

export const UserBubble = styled(Box)(({ theme }) => ({
  borderRadius: 10,
  padding: '10px 15px',
  backgroundColor: theme.palette.primary.light,
  color: theme.palette.text.primary,
  maxWidth: '70%',
  wordWrap: 'break-word',
  marginBottom: 10,
  marginLeft: 'auto',
}));

export const ChatContainer = styled(Box)({
  display: 'flex',
  height: '650px',
  width: '400px',
  flexDirection: 'column',
  padding: 10,
  overflowY: 'auto',
  border: '2px #f5f5f5 solid',
  boxShadow: '0px 0px 10px 0px rgba(0,0,0,0.1)',
  opacity: 1,
  backgroundColor: '#fff',
  borderRadius: 10,
  zIndex: 1000,
  transition: 'transform 0.5s linear',
  position: 'relative',
});

export const ChatHeader = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  borderBottom: '2px solid #f5f5f5',
  padding: '10px',
  marginBottom: 10,
});

export const ChatMessagesContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  height: 'calc(100% - 150px)',
  width: '100%',
  overflowY: 'auto',
  padding: '10px',
});

export const ChatTextBox = styled(Box)({
  display: 'flex',
  flexDirection: 'row',
  padding: '0px 10px',
  width: '100%',
  position: 'absolute',
  bottom: 0,
  left: 0,
});

export const ChatTextInput = styled(TextField)({
  width: '78%',
  borderRadius: 10,
  padding: '10px',
  backgroundColor: '#f5f5f5',
  marginBottom: 10,
});

export const ChatTextSend = styled(Box)({
  padding: '10px',
  width: '18%',
});

export const StyledSendIcon = styled(SendIcon)(({ theme }) => ({
  fill: 'white',
  'button:hover &': {
    fill: theme.palette.primary.main,
  },
}));
